import styled from '@emotion/styled';
import css from '@emotion/css';
import { device } from './device';

interface IStyledSynopsis {
    theme?: { [key: string]: any };
    type?: string;
    dataFont?: string;
}

export const Synopsis = styled.section<IStyledSynopsis>`
position: relative;
font-size: 16px;
line-height: 28px;
font-weight: 500;
color: #595959;

${(props: IStyledSynopsis) => props.type == "synopsis" && css`
    &::after{
        position: absolute;
        content: "";
        height: 50%;
        width: 100%;
        left: 0;
        bottom: 0;
        //background-image: linear-gradient(180deg,hsla(0,0%,100%,0) -7%,#fff);
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.83) 52.6%, #FFFFFF 100%);
        visibility: visible;
    }    
`} 

${(props: IStyledSynopsis) => props.dataFont == "small" && css`
    font-size: 14px;
    line-height: 24px;
`}

${(props: IStyledSynopsis) => props.dataFont == "large" && css`
    font-size: 18px;
    line-height: 30px;
`}

${(props: IStyledSynopsis) => props.dataFont == "medium" && css`
    font-size: 16px;
    line-height: 28px;
`}

br{
    content: '';
    margin: 8px 0;
    display:flex;
}

`

export const SynopsisWrapper = styled.section`
  margin: 32px 0 0 0;
  @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
      padding:0 24px;
      margin: 24px 0 0 0;
   }
`